// extracted by mini-css-extract-plugin
export default {"coreImg":"StatementScreen_coreImg__fd2EW"};